import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       
        <p>
          WhatsApp.
        </p>
        <a
          className="App-link" 
          href="https://web.whatsapp.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Abrir
        </a>
      </header>
    </div>
  );
}

export default App;
